import React from 'react';

function DeleteAccount() {
    return (
        <>
            <section className="blog_detail_section">
                <div className="container">
                    <div className="blog_inner_pannel">
                        <div className="section_title">
                            <h2>How to Permanently Delete Your MiSoulmate Account</h2>
                        </div>
                        <div className="info">
                            <p>
                                At MiSoulmate, we respect your privacy and give you full control over your data.
                                If at any time you wish to permanently delete your account and associated personal information,
                                you can easily do so from within the app.
                            </p>

                            <h3>Steps to Delete Your Account</h3>
                            <ul>
                                <li><strong>1.</strong> Open the <strong>MiSoulmate App</strong> on your iOS or Android device.</li>
                                <li><strong>2.</strong> <strong>Log in</strong> to your account using your registered email or phone number.</li>
                                <li><strong>3.</strong> From the home screen, tap the <strong>Profile icon</strong> on the bottom-right corner of the navigation bar.</li>
                                <li><strong>4.</strong> In the Profile tab, tap <strong>“Account Settings”</strong>.</li>
                                <li><strong>5.</strong> Scroll to the bottom of the Account Settings screen.</li>
                                <li><strong>6.</strong> Tap on <strong>“Delete Account Permanently”</strong>.</li>
                                <li><strong>7.</strong> A confirmation popup will appear. Tap <strong>“Delete”</strong> to confirm.</li>
                            </ul>

                            <h3>What Happens When You Delete Your Account?</h3>
                            <ul>
                                <li>✅ Your user account will be deleted from our systems permanently.</li>
                                <li>✅ All personal information, profile data, and uploaded images will be erased.</li>
                                <li>✅ You will be logged out immediately.</li>
                                <li>❌ This action is irreversible. To use MiSoulmate again, you’ll need to register a new account.</li>
                            </ul>

                            <h3>Data That Is Deleted</h3>
                            <ul>
                                <li>✔️ User profile and registration information</li>
                                <li>✔️ Uploaded profile and match photos</li>
                                <li>✔️ Preferences, filters, and communication history</li>
                            </ul>

                            <h3>Data That May Be Temporarily Retained</h3>
                            <p>
                                MiSoulmate may retain anonymized system logs or data for <strong>fraud prevention, legal, or safety</strong> purposes. This data is not linked to your identity and is removed within the shortest legally required time frame.
                            </p>

                            <h3>Need Help?</h3>
                            <p>
                                For assistance, please contact us at <strong>support@misoulmate.com</strong>. Our support team will assist with any account-related requests.
                            </p>

                            <p><strong>Last Updated:</strong> July 1, 2025</p>
                        </div>

                        <div className="quote_block">
                            <h2>"You’re in control — your privacy is our commitment."</h2>
                            <p><span className="name">MiSoulmate Inc.,</span> Privacy & Support Team</p>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default DeleteAccount;
